import { render, staticRenderFns } from "./queryCustomer.vue?vue&type=template&id=57c0806b&scoped=true&"
import script from "./queryCustomer.vue?vue&type=script&lang=js&"
export * from "./queryCustomer.vue?vue&type=script&lang=js&"
import style0 from "./queryCustomer.vue?vue&type=style&index=0&id=57c0806b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c0806b",
  null
  
)

export default component.exports